module.exports = __webpack_public_path__ + "img/trustpilot-static.37151c4d.svg";